import type { ExtendedIconButtonProps } from '@src/shared/ui/Button/IconButton';
import { ArrowRightIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import NavIconButton from './NavIconButton';

const NextIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();

    return (
      <NavIconButton
        ref={ref}
        {...props}
        tooltipTitle={props.tooltipTitle ?? t('common.next', 'Next')}
      >
        <ArrowRightIcon />
      </NavIconButton>
    );
  },
);

export default NextIconButton;
